const DriverDrawerSkeleton = ({ closeDrawer }: { closeDrawer: () => void }) => {
  return (
    <div className='flex h-full w-full flex-col'>
      {/* Header */}
      <div className='py-5'>
        <div className='mb-5 flex items-center justify-between'>
          <div className='h-8 w-48 animate-pulse rounded bg-gray-3' />
        </div>

        {/* Name input */}
        <div className='mb-4'>
          <div className='mb-2 h-4 w-32 animate-pulse rounded bg-gray-3' />
          <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
        </div>

        {/* Phone and App access */}
        <div className='flex gap-4'>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-24 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-28 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
        </div>
      </div>

      {/* Identifier section */}
      <div className='border-gray-3 border-t border-b py-5'>
        <div className='mb-2 h-4 w-28 animate-pulse rounded bg-gray-3' />
        <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
      </div>

      {/* Documents section */}
      <div className='py-5'>
        <div className='mb-6 h-6 w-48 animate-pulse rounded bg-gray-3' />

        <div className='mb-4 flex gap-4'>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-24 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-24 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
        </div>

        <div className='flex gap-4'>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-24 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
          <div className='flex-1'>
            <div className='mb-2 h-4 w-24 animate-pulse rounded bg-gray-3' />
            <div className='h-10 w-full animate-pulse rounded bg-gray-3' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverDrawerSkeleton;
